import {
  ISharedFileRequestResponse,
  SharedFileRequestStatus
} from "@wingspanhq/shared-files/dist/lib/interfaces";
import { selectorIsSharedFileNotNoneContext } from "./selectorIsSharedFileNotNoneContext";

export function selectorIsSharedFileReUploadFlow(
  sharedFile: ISharedFileRequestResponse | undefined
): boolean {
  return (
    selectorIsSharedFileNotNoneContext(sharedFile?.contextType) &&
    sharedFile?.status === SharedFileRequestStatus.PendingSubmission
  );
}
